import React from 'react';

const FacebookContext = React.createContext({});

export default FacebookContext;
